import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "antd";
//OTHER IMPORTS
import dayjs from "dayjs";

//PROJECT IMPORTS
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../wallet.config";

const { Text } = Typography;

const AddSubWallet = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [productData, setProductData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [kycLevelOptions, setKycLevelOptions] = useState([]);
  const [customerSegmentOptions, setCustomerSegmentOptions] = useState([]);
  const [transactionRestriction, setTransactionRestriction] = useState([]);
  const [statementCycleOptions, setStatementCycleOptions] = useState([]);
  const [filteredWalletProduct, setFilteredWalletProduct] = useState({});
  const [savingsAccountData, setSavingsAccountData] = useState({});
  const [parentParam, setParentParam] = useState(null);

  const dateFormat = "DD-MM-YYYY";

  useEffect(() => {
    console.log(state);
    defaultDate();
    onChangeProduct(state?.contractObj?.productId);
    useForm.setFieldsValue({
      productId: state?.contractObj?.productId,
    });
    setSavingsAccountData(state?.contractObj?.savingsAccountData);
    setParentParam(state?.contractObj?.parentId);
  }, []);

  const defaultDate = () => {
    useForm.setFieldsValue({
      submittedOnDate: dayjs(),
    });
  };

  const onChangeProduct = (productParam) => {
    console.log("Selected Product ID:", productParam);

    const params = {
      // clientId: customerInfo.id,
      productId: productParam,
    };

    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.walletsProductDataList.find(
          (data) => data.id === productParam
        );
        let tempCurrency = objList?.currency;
        let tempCustomerSegmentOptions = [];
        let temptransactionRestriction = [];
        let tempStatementCycleOptions = [];
        let tempKycOptions = [];
        let tempProducts = [];

        useForm.setFieldsValue({
          // productId: objList?.productParam,
          currencyName: `${objList?.savingsProductData?.currency?.name} (${objList?.savingsProductData?.currency?.displaySymbol})`,
          decimalPlaces: objList?.savingsProductData?.currency?.decimalPlaces,
          inMultiplesOf: objList?.savingsProductData?.currency?.inMultiplesOf,
          kycLevel: objList?.kycLevel,
          customerSegment: objList?.customerSegments?.map((seg) => seg.id),
          transactionRestriction: objList?.transactionRestrictions?.map(
            (seg) => seg.id
          ),
          statementCycle: objList?.statementCycles?.map((seg) => seg.id),
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
        });

        res?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.savingsProductData.name
              ? `${element.savingsProductData.name} (${element.id})`
              : "",
          });
        });

        res?.walletsProductData.customerSegmentTypes?.forEach((element) => {
          tempCustomerSegmentOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData.transactionRestrictionTypes?.forEach(
          (element) => {
            temptransactionRestriction.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        res?.walletsProductData.statementCycleTypes?.forEach((element) => {
          tempStatementCycleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData?.kycLevelTypes?.forEach((element) => {
          tempKycOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setProductData(tempProducts);
        setCurrencyData(tempCurrency);
        setKycLevelOptions(tempKycOptions);
        setCustomerSegmentOptions(tempCustomerSegmentOptions);
        setTransactionRestriction(temptransactionRestriction);
        setStatementCycleOptions(tempStatementCycleOptions);
        setIsProductSelected(true);
        setFilteredWalletProduct(objList);
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-wallet-account", { state: state });
  }

  const onSubmit = (formValues) => {
    formValues.submittedOnDate = BOM.DateTime(
      formValues.submittedOnDate,
      "only-date"
    );
    formValues.clientId = savingsAccountData.clientId;
    formValues.parentId = parentParam;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.locale = "en";

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.WalletAccount,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newSubWalletAccountMsg);
          navigate("/detail-wallet-account", { state: { ...state } });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-wallet-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout
      pageItems={staticConfig.addSubWalletAccountBreadcrumbItems}
      onSave={onSubmit}
    >
      <TopContent
        pageTitle={labelConfig.newSubWallet}
        createPageTitle={labelConfig.createSubWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">
                <Text type="secondary">Parent Account: </Text>
                <Text strong>{state.contractObj?.nubanNumber}</Text>
              </Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label="Sub-Wallet Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter sub-wallet name",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Account Holder's Name"
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label="External ID"
                  name="externalId"
                  // rules={[
                  //   { required: true, message: "Please enter External ID" },
                  // ]}
                >
                  <Input
                    placeholder="e.g. SUBWALLET-01"
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      {labelConfig.productName}
                      <Tooltip title="Select Product Name">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </Space>
                  }
                  name={"productId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.productName),
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    showSearch
                    disabled
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.productName,
                      "select"
                    )}
                    optionFilterProp="children"
                    style={{ height: "44px" }}
                    onChange={onChangeProduct}
                    options={productData}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.createdDate}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.createdDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabled
                    className="of-bold-disable-input"
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.createdDate,
                      "select"
                    )}
                    style={{ width: "100%", height: 44 }}
                    format={dateFormat}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Statement cycle"} name={"statementCycle"}>
                  <Select
                    className="read-only-select"
                    mode="multiple"
                    disabled
                    style={{ height: "44px" }}
                    options={statementCycleOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <span>
                      KYC Level
                      <Tooltip title="Select the KYC Level">
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name="kycLevel"
                  rules={[
                    {
                      required: true,
                      message: "Please select KYC Level",
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder="Select KYC Level"
                    style={{ height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={kycLevelOptions}
                    // mode="multiple"
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <span>
                      Transaction Restriction
                      <Tooltip title="Select a transaction restriction">
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name="transactionRestriction"
                  rules={[
                    {
                      required: true,
                      message: "Please select a transaction restriction",
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder="Select a transaction restriction"
                    style={{ height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={transactionRestriction}
                    mode="multiple"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <span>
                      Customer Segment
                      <Tooltip title="Select the customer segment">
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name="customerSegment"
                  rules={[
                    {
                      required: true,
                      message: "Please select the customer segment",
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder="Select the customer segment"
                    style={{ height: 44 }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    options={customerSegmentOptions}
                    mode="multiple"
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  backgroundColor: "#BA24D5",
                  color: "white",
                  border: "1px solid #BA24D5",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                htmlType="submit"
                backgroundColor="#BA24D5"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  backgroundColor: "#BA24D5",
                  color: "white",
                  border: "1px solid #BA24D5",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default AddSubWallet;
